// BaseKeyNumberGrid.jsx
import React, { useMemo, useCallback } from 'react';
import CustomDataGridResult from 'utils/Datagrid/CustomForecastDataGridResult';
import { customDataGridResultSimulation } from 'utils/Datagrid/CustomForecastDataGridUtils';

const GROUPING_COL_DEF = {
  headerName: '',
  width: 40,
  minWidth: 40,
  maxWidth: 40,
};

const getTreeDataPath = (row) => row.hierarchy;

const BaseKeyNumberGrid = ({
  rows,
  columns,
  getCellClassName,
  customToolbar,
  treeData = true,
  isGroupExpandedByDefault,
}) => {
  const flattenedRows = useMemo(
    () => rows.map((r) => ({ id: r.id, hierarchy: r.hierarchy, isChild: !!r.isChild })),
    [rows],
  );

  const getRowClassName = useCallback(
    (params) => {
      const row = flattenedRows.find((r) => r.id === params.id);
      return row?.isChild ? 'Mui-even row-child' : 'Mui-even';
    },
    [flattenedRows],
  );

  return (
    <CustomDataGridResult
      rows={rows}
      columns={columns}
      isLoading={false}
      theme={customDataGridResultSimulation}
      simulationContext={'simulation-box'}
      fullSize={true}
      treeData={treeData}
      getTreeDataPath={getTreeDataPath}
      groupingColDef={GROUPING_COL_DEF}
      defaultGroupingExpansionDepth={0}
      fromKeyNumberNitrogen={true}
      fromCapPointsSimulation={true}
      getRowClassName={getRowClassName}
      getCellClassName={getCellClassName}
      customToolbar={customToolbar}
      isGroupExpandedByDefault={isGroupExpandedByDefault}
    />
  );
};

export default BaseKeyNumberGrid;
